import axios from "axios"

const baseUrl = process.env.VUE_APP_BASE_URL

const oecdguidelines = 
{
    namespaced: true,
    state: {
        oecdguidelines: [],
        oecdguideline: {}
    },
    mutations: {
        SET_OECDGUIDELINES(state, data)
        {
            state.oecdguidelines = data
        },
        SET_OECDGUIDELINE(state, data)
        {
            state.oecdguideline = data
        }
    },
    actions: {
        getAll ({ commit }) {
          return axios 
          .get(baseUrl+'GHSOECDGuidelines', { withCredentials: true })
          .then(res => {
              console.log(res.data);
              commit('SET_OECDGUIDELINES', res.data)
             
          })
          .catch(error => console.log(error))
        },

        deleteOECDGuidlines ({ commit }, id) {
            return axios
            .get(baseUrl+'DeleteVendor?vendorId=' + id, { withCredentials: true })
            .catch(error => console.log(error))
          },
          updateOECDGuidelines ({ commit },{id, data}){
            return axios
            .post(baseUrl+'GHSOECDGuidelines/updateOECDGuidelines/'+id, data, { withCredentials: true })
            .then(res => {

                console.log(res)
            })
          },
          
          //This get vendor is used to get a fresh copy from the db to load full details. the getter vendor is used to get current grid vendor
          getOECDGuidelines ({ commit },id) {
            return axios
            .get(baseUrl+'GetVendor?vendorId=' + id, { withCredentials: true })
            .then(res => {
                commit('SET_VENDOR', res.data)
            })
            .catch(error => console.log(error))
        },
        addNewOECDGuidelines ({ commit }, data) {
            return axios
            .post(baseUrl+'GHSOECDGuidelines/addOECDGuidelines', data, { withCredentials: true },)
            .then(res => {
                console.log("new OECD added",res.data)
            })
            .catch(error => console.log(error))
        }
      },
      getters: {}
}

export default oecdguidelines